<rt-group variant="horizontal stacked">
  <rt-button
    [disabled]="!canGoToPrevPage"
    (click)="pageChange.emit(page - 1)"
    variant="simple small only-icon"
  >
    <rt-icon name="keyboard-arrow-left"></rt-icon>
  </rt-button>

  <rt-button
    [disabled]="!canGoToNextPage"
    (click)="pageChange.emit(page + 1)"
    variant="simple small only-icon"
  >
    <rt-icon name="keyboard-arrow-right"></rt-icon>
  </rt-button>
</rt-group>
